import { useCallback, useState } from 'react';
import { useNavigate } from "react-router-dom";
import './CreateAdventure.css';
import backend from './backend';

function CreateAdventure() {
  const [adventureName, setAdventureName] = useState<string>("");
  const [rpg, setRpg] = useState<string>("dnd2024");
  const navigate = useNavigate();

  const createAdventure = useCallback(() => {
    if (adventureName.trim()) {
      (async () => {
        const response = await backend.createAdventure(adventureName, rpg);
        if (response.ok) {
          navigate(`/${(await response.json()).id}`);
        }
      })();
    }
  }, [adventureName, rpg, navigate]);

  return (
    <div className="newadventurecontainer">
      <div className="spacer"></div>
      <h1>SquiggleBoard</h1>
      <div className="newadventureform">
        <div className="newadventureinputcolumn">
          <div className="newadventureinputrow">
            <span>New adventure:</span>
            <input type="text" placeholder='name of adventure' value={adventureName} onChange={e => setAdventureName(e.target.value)} autoFocus />
          </div>
          <div className="newadventureinputrow">
            <span>Game system (optional):</span>
            <select value={rpg} onChange={e => setRpg(e.target.value)}>
              <option value="none">None</option>
              <optgroup label="Most common">
                <option value="dnd5e">D&amp;D 5e</option>
                <option value="dnd2024">D&amp;D 5.5e (2024)</option>
                <option value="pathfinder">Pathfinder</option>
                <option value="callOfCthulhu">Call of Cthulhu</option>
              </optgroup>
              <optgroup label="Popular">
                <option value="bladesInTheDark">Blades in the Dark</option>
                <option value="cyberpunk">Cyberpunk</option>
                <option value="shadowrun">Shadowrun</option>
                <option value="starWars">Star Wars</option>
                <option value="vampireTheMasquerade">Vampire: The Masquerade</option>
                <option value="warhammer">Warhammer</option>
              </optgroup>
              <optgroup label="Other">
                <option value="other">(other)</option>
              </optgroup>
            </select>
          </div>
        </div>
        <div className="newadventurebuttoncolumn">
          <button onClick={createAdventure} className={adventureName === "" ? "disabled": ""}>Create</button>
        </div>
      </div>
      <div className="newadventurereminder">After creating your adventure you must save the resulting URL, perhaps by bookmarking it. It is the only way to find it again!</div>
      <div className="spacer"></div>
      <div className="newadventuredisclaimer">This application is an independent tool for tabletop role-playing games. All RPG titles, trademarks, and product names that may be referenced are the property of their respective owners. Except where explicitly stated, this app is not affiliated with, endorsed, or sponsored by any publisher or rights holder.</div>
    </div>
  );
}

export default CreateAdventure;
